export enum TipoDeModalAcoesDocumento {
  COMPARTILHAR = 'compartilhar',
  HISTORICO = 'historico',
  FINALIZAR_ENVIO_AO_PAPEL_ZERO = 'finalizarEnvioAoPapelZero',
}
